<template>
    <Page type="no-helpers">
        <PageHeader back="home">
            {{ $t('pageTitle') }}
        </PageHeader>
        <div class="page-icon">
            <IconProfile classes="mx-auto" height="75" />
        </div>
        <form @submit.prevent="register" class="form max-w-screen-sm mx-auto">
            <div class="group" :class="{ 'has-error' : hasError('name') }">
                <label for="name">{{ $t('name') }}</label>
                <input type="text" :placeholder="$t('name-placeholder')" v-model="name" required>
                <div v-if="hasError('name')">
                  <div class="error-description" v-for="error in errors.name" :key="error">
                      {{ $t('errors.'+error) }}
                  </div>
                </div>
            </div>
            <div class="group" :class="{ 'has-error' : hasError('city') }">
                <label for="city">{{ $t('city') }}</label>
                <div class="oneline" v-if="city.auto.loaded">
                  <div class="radio"><input type="radio" value="auto" v-model="selected"></div>
                  <div class="p-11" @click="selected='auto'">
                    {{ city.auto.name }}
                    <div class="text-xs">{{ $t('city-selected') }}</div>
                  </div>
                </div>
                <div class="oneline">
                  <div class="radio" v-if="city.auto.loaded"><input type="radio" value="manual" v-model="selected"></div>
                  <div class="w-full">
                    <div class="p-11" v-if="selected != 'manual'"><a @click="beginComplete">Ввести вручную</a></div>
                    <input type="text" :placeholder="$t('city-placeholder')" id="city"
                      v-if="selected == 'manual'"
                      v-model="cityName" 
                      @focus="beginComplete" @focusout="endComplete"
                      @keyup="complete"
                      required>
                    <div class="autocomplete" :class="completeOpen?'':'invisible'">
                      <div class="list -mt-11" v-if="cities.length">
                        <div class="item" v-for="(city, index) in cities" :key="city.name" @click="select(index)">
                          {{ city.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="hasError('city')">
                  <div class="error-description" v-for="error in errors.city" :key="error">
                      {{ $t('errors.'+error) }}
                  </div>
                </div>
            </div>
            <div class="group" :class="{ 'has-error' : hasError('email') }">
                <label for="email">{{ $t('email') }}</label>
                <input type="email" placeholder="user@example.com" v-model="email" required>
                <div v-if="hasError('email')">
                  <div class="error-description" v-for="error in errors.email" :key="error">
                      {{ $t('errors.'+error) }}
                  </div>
                </div>
            </div>
            <div class="group" :class="{ 'has-error' : hasError('password') }">
                <label for="password">{{ $t('password') }}</label>
                <input type="password" v-model="password" required>
                <div v-if="hasError('password')">
                  <div class="error-description" v-for="error in errors.password" :key="error">
                      {{ $t('errors.'+error) }}
                  </div>
                </div>
            </div>
            <div class="group">
                <label for="password_confirmation">{{ $t('passwordConfirmation') }}</label>
                <input type="password" v-model="password_confirmation" required>
            </div>

            <div class="error" v-if="errorsHappened">
                {{ hasError('connection') ? $t('errors.connection') : $t('errors.validation') }}
            </div>

            <BigButton :disable="disable" @clicked="register">
              {{ $t('register') }}
            </BigButton>
            <div class="group text-center text-prime-500 underline">
                <router-link :to="{ name: 'login' }">{{ $t('login') }}</router-link>
            </div>
        </form>
    </Page>
</template>
<script>
import IconProfile from '@/components/visual/icons/IconProfile'
import Page from '@/components/visual/Page'
import BigButton from '@/components/visual/BigButton'
import PageHeader from '@/components/visual/PageHeader'
import { mapState, mapGetters } from 'vuex'

export default {
    components: { IconProfile, Page, PageHeader, BigButton },
    data() {
      return {
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        selected: undefined, 
        cityName: '',
        completeOpen: false,
      }
    },
    methods: {
      complete(event) {
          this.$store.dispatch('city/complete', event.target.value)
      },
      beginComplete() {
        this.completeOpen = true
        this.selected = 'manual'
        setTimeout(() => { document.getElementById('city').focus() }, 100)
      },
      endComplete() {
        setTimeout(() => { this.completeOpen = false }, 10)
      },
      select(index) {
        this.$store.dispatch('city/select', index)
          .then(() => {
            this.cityName = this.city.manual.name
          })
      },
      register() {
        this.$store.dispatch('errors/clear')
        this.$store.dispatch('auth/register', this.credentials)
          .then(() => {
            if (! this.errorsHappened) {
              this.$store.dispatch('message/show', this.$t('success'))
              this.$router.push({ name: 'login' })
            }
          })
      }
    },
    created() {
      this.$store.dispatch('city/detect')
        .then(() => {
          setTimeout(() => {
            if (this.city.auto.loaded)
              this.selected = 'auto'
          }, 200)
        })
    },
    computed: {
      credentials() {
        var credentials = { 
          name: this.name,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
          type: this.selected 
        }
        if (this.selected == 'manual') {
          credentials.city = this.city.manual.name
          credentials.placeid = this.city.manual.placeid
        } else {
          credentials.city = this.city.auto.name
          credentials.longitude = this.city.auto.longitude
          credentials.latitude = this.city.auto.latitude
        }
        return credentials
      },
        ...mapGetters('loading', {
            disable: 'disable',
        }),
        ...mapGetters('errors', {
            errorsHappened: 'happened',
            hasError: 'has',
        }),
        ...mapState('errors', {
            errors: state => state.errors
        }),
        ...mapState('city', ['city', 'cities'])
    }
  }
</script>

<i18n locale="ru" lang="yaml">
  pageTitle: "Регистрация"
  name: "Имя"
  name-placeholder: "Ваше имя"
  city: "Ваш город"
  city-selected: "(определен автоматически)"
  city-placeholder: "Начните вводить и выберите из списка"
  email: "Электронная почта"
  password: "Пароль"
  passwordConfirmation: "Подтверждение пароля"
  register: "Зарегистрироваться"
  success: "Поздравляем с регистрацией! Мы отправили вам письмо для подтверждения электронной почты. Подтвердите ее, перейдя по ссылке в письме, чтобы пользоваться всеми возможностями программы."
  errors:
    validation: "Проверьте все данные еще раз"
    connection: "Невозможно зарегистрироваться сейчас, попробуйте позже."
    name:
        required: "Имя обязательно нужно"
        string: "В имени нельзя писать загадочные символы"
        min: "Имя должно быть хотя бы из трех букв"
    email:
        required: "Элетронная почта обезательно нужна"
        email: "Электронная почта должна быть настоящей"
        unique: "С такой электронной почтой уже кто-то зарегистрировался. Если это вы, то вы можете восстановить пароль на странице входа"
    password:
        required: "Пароль обязательно нужен"
        min: "Пароль должен быть не меньше 8 символов"
        confirmed: "Пароль и подтверждение пароля должны совпадать"
</i18n>

<i18n locale="en" lang="yaml">
  pageTitle: "Registration"
  name: "Name"
  name-placeholder: "Your name"
  city: "Your city"
  city-selected: "(detected automaticaly)"
  city-placeholder: "Start typing and select from list"
  email: "Email"
  password: "Password"
  passwordConfirmation: "Confirm password"
  register: "Register"
  success: "Congratulations! You've been registered. We sent you a mail with confirmation link. Please comfirm your email by clickin a link to use all the features."
  login: "Я уже зарегистрирован. Войти"
  errors:
    validation: "Please provide correct data"
    connection: "Can't register right now, please try later"
    name:
        required: "Name is required"
        string: "Please use only letters and numbers"
        min: "Name must be at least 3 letters"
    email:
        required: "Email is required"
        email: "Please provide correct email"
        unique: "Somebody already registered with this mail. You can reset password on Login page if that were you."
    password:
        required: "Password is required"
        min: "Password must be at least 8 symbols"
        confirmed: "Password and confirmation must be the same"
</i18n>
